
import React, { MouseEventHandler } from 'react';
import './alert.css';
import { useAppDispatch, useAppSelector } from '../../store/storeRequests';
import StoreSelectors from '../../utils/constants/StoreSelectors.constants';
import Modal from 'react-bootstrap/Modal';
import closeIcon from '../../assets/close.svg';
import successIcon from '../../assets/checkmark-outlined.svg';
import failureIcon from '../../assets/close-icon.svg';
import { closeAlert } from '../../store/Alert/alert.actions';
import CustomButton from '../CustomButton/CustomButton';

export interface CustomAlertProps {
  show: boolean;
  variant: 'success' | 'danger' | 'warning' | 'info';
  message: string;
  title: string;
  closeLabel?: string;
  proceedCallback?: MouseEventHandler<HTMLButtonElement>;
  cancelCallback?: MouseEventHandler<HTMLButtonElement>;
}

const Alert: React.FunctionComponent<CustomAlertProps> = ({ proceedCallback, cancelCallback, show, variant, message, title, closeLabel }) => {
  const dispatch = useAppDispatch();
  const alertState = useAppSelector(StoreSelectors.ALERT_STATE);

  const closeAlertPopup = () => {
    if (cancelCallback) {
      dispatch(closeAlert(cancelCallback));
    } else {
      dispatch(closeAlert(() => {}));
    }
  };

  const onModalOpens = () => {
    const body = document.getElementById('MFCentralAdminBody');
    if (body) {
      body.classList.add('remove-padding');
    }
  };

  return (
    <Modal
      show={show}
      className="alert-modal border-0"
      backdropClassName="alert-backdrop"
      backdrop="static"
      onEntered={onModalOpens}
    >
      <Modal.Header className="justify-content-end border-0 position-relative">
        <div className="cursor-pointer mf-modal-close" onClick={closeAlertPopup}>
          <img width="25" height="25" src={closeIcon} alt="close" />
        </div>
      </Modal.Header>
      <Modal.Body className="alert-modal-body">
        <div className="alert-modal-img text-center mb-4">
          <img width={64} height={64} src={variant === 'success' ? successIcon : failureIcon} alt={variant} />
        </div>
        <div className="alert-body-message mx-auto">
          <p className="mb-0 text-primary-color text-center text-capitalize font-16 weight-500">{message}</p>
        </div>
        <div className="alert-action-btns text-center mt-4">
          <button type="button" className="text-center border-0 close-only-btn text-capitalize weight-600 text-primary-color font-14" onClick={closeAlertPopup}>
            {closeLabel || 'Close'}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Alert;
